import styled from 'styled-components'

export const LanguageSwitchContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;

  cursor: pointer;

  .language-text {
    cursor: pointer;
  }
`
